import { Plus } from "lucide-react";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";

export default function ManagementHeader({
  title,
  subtitle,
  icon: Icon,
  buttonText,
  onButtonClick,
  showAdd = true,
  showBack = false,
  backTo = "/",
  backLabel = "Back",
}) {
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center justify-content-between mb-4 w-100">
      {/* Left: Icon + Title + Subtitle */}
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center gap-3">
          {showBack && (
            <Tooltip title={backLabel} placement="bottom">
              <span>
                <MdArrowBack
                  size={28}
                  className="icon-btn"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(backTo)}
                />
              </span>
            </Tooltip>
          )}
          {Icon && <Icon size={36} className="icon-btn" />}

          {/* Title + Subtitle column */}
          <div className="d-flex flex-column">
            <h1 className="text-3xl font-bold m-0 page-title">{title}</h1>
            <p className="mt-1 text-sm page-subtitle">{subtitle}</p>
          </div>
        </div>
      </div>

      {/* Right: Button */}
      {showAdd && (
        <button
          onClick={onButtonClick}
          className="action-btn flex items-center gap-2 px-5 py-2 rounded-lg font-semibold transition-colors shadow-lg hover:shadow-xl"
        >
          <Plus size={18} />
          {buttonText}
        </button>
      )}
    </div>
  );
}
